import {SessionGender, useSessionGender} from '@aboutyou/logic-components';
import {useHistory, useQueryParams} from '@aboutyou/router';
import {usePrevious} from '@aboutyou/utils';
import {useEffect} from 'react';

/**
 * Fix for: https://aboutyou.atlassian.net/browse/ASFE-6154
 */
export const ResetGenderOnHistoryBack = () => {
  const queryParams = useQueryParams();
  const currentParamGender = queryParams.get('gender');
  const previousParamGender = usePrevious(currentParamGender);

  const {updateGender} = useSessionGender();
  const history = useHistory();

  // eslint-disable-next-line local-rules/prefer-use-query-params-callback
  useEffect(() => {
    return history.listen((_location, action) => {
      if (action === 'POP') {
        // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
        updateGender(previousParamGender as SessionGender);
      }
    });
  }, [history, currentParamGender, previousParamGender, updateGender]);

  return null;
};
